<template>
  <v-container grid-list-xl fluid>
    <v-layout justify-center>
      <v-flex>
        <v-layout>
          <v-flex>
            <template>
              <v-data-table
                :items="ultimoAcuerdo"
                class="elevation-1"
                hide-actions
                hide-headers
              >
                <template v-slot:items="props">
                  <td class="text-xs-left">Estado ultimo acuerdo</td>
                  <td class="text-xs-left">{{ props.item.estado }}</td>
                  <td class="text-xs-left">Fecha</td>
                  <td class="text-xs-left">{{ props.item.fechaAcuerdo }}</td>
                  <td class="text-xs-left">Total acuerdos</td>
                  <td class="text-xs-left">{{ props.item.cantidad }}</td>
                  <td
                    class="blue--text"
                    style="cursor: pointer"
                    @click="loadDataHistorico"
                  >
                    <u>Ver historico</u>
                  </td>
                </template>
              </v-data-table>
            </template>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- DIALOGO DE HISTORICO DE ACUERDO -->
    <template>
      <v-dialog v-model="dialogGrid" persistent max-width="800">
        <v-card>
          <v-card-title class="headline">Historico de acuerdos</v-card-title>
          <v-card-text>
            <div v-if="loadingGrid">
              <loading-grid></loading-grid>
            </div>
            <div v-if="alertaGrid">
              <alert-empty></alert-empty>
            </div>
            <v-spacer></v-spacer>
            <v-data-table
              :headers="headers"
              :items="acuerdoHistorico"
              :pagination.sync="miPaginacion"
              hide-actions
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.idAcuerdo.id }}</td>
                <td class="text-xs-left">{{ props.item.estado }}</td>
                <td class="text-xs-left">{{ props.item.fechaModificacion }}</td>
                <v-btn
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="green darken-4"
                  small
                  title="Ver detalle"
                  @click="viewDetalleAcuerdoHistorico(props.item.idAcuerdo.id)"
                >
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
              </template>
            </v-data-table>
            <!-- PAGINACION -->
            <v-flex xs12 sm6>
              <v-text-field
                value=""
                label="Total de Registros"
                v-model="miPaginacion.totalItems"
                disabled
              ></v-text-field>
            </v-flex>
            <div class="pt-2">
              <v-pagination
                v-model="miPaginacion.page"
                :length="numPaginas"
                :total-visible="7"
                circle
              ></v-pagination>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="dialogGrid = false"
              >Cerrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <!-- DIALOGO DE HISTORICO DE ACUERDO -->
  </v-container>
</template>

<script>
import axios from "axios";
import LoadingGrid from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";

export default {
  name: "botones-acuerdo-mecanizado",

  components: {
    LoadingGrid,
    AlertEmpty,
  },

  props: {
    tabSelected: "",
  },

  data() {
    return {
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      loadingGrid: false,
      alertaGrid: false,
      proveedor: {},
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      index: "",
      ultimoAcuerdo: [],
      botonEstado: {},
      acuerdoHistorico: [],
      headers: [
        {
          text: "Código de Acuerdo",
          align: "left",
          sortable: false,
          value: "idARegistro",
        },
        //{ text: "Descripcion", align: "left", sortable: false, value: "idAcuerdo" },
        { text: "Estado", sortable: false, value: "estado" },
        { text: "Fecha del acuerdo", sortable: false, value: "fecha" },
        { text: "Accion", sortable: false, value: "" },
      ],
      usuarioLogged: "",
      dialog: false,
      dialogGrid: false,
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
    this.loadData();
  },
  created() {},
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    async loadUltimoAcuerdo() {
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idContrato = this.$store.getters.contratoStored;

      return await axios
        .get("/acuerdo/ultimo/contrato/" + idContrato + "/" + subProceso)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    async loadData() {
      this.botonEstado = await this.loadUltimoAcuerdo();
      this.ultimoAcuerdo = [this.botonEstado];
      this.loadingGrid = false;
    },

    viewDetalleAcuerdoHistorico(id) {
      this.$router.push({
        name: "DetalleHistoricoAcuerdo",
        params: { idAcuerdo: id, tipeView: "consulta" },
      });
    },

    async loadDocumentosHistorico() {
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idContrato = this.$store.getters.contratoStored;
      return await axios
        .get(
          "/acuerdos/historico/contrato/" +
            idContrato +
            "/subproceso/" +
            subProceso
        )
        .then(function (response) {
          console.log(response.data);
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadDataHistorico() {
      this.loadingGrid = true;
      this.dialogGrid = true;
      this.acuerdoHistorico = await this.loadDocumentosHistorico();
      this.miPaginacion.totalItems = this.acuerdoHistorico.length;

      if (this.acuerdoHistorico.length > 0) {
        this.alertaGrid = false;
      } else {
        this.alertaGrid = true;
      }

      this.loadingGrid = false;
    },

    async reloadGrid() {
      await this.$parent.$parent.reloadBoton();
      await this.$parent.$parent.reloadDocumento();
    },
  },
};
</script>
